import {Component, OnInit} from '@angular/core';
import {Booking} from '../../../../../domain/booking/booking';
import {RbRoutingService} from '../../../../../core/services/rb-routing.service';
import {BookingStoreService} from '../../../../../domain/booking/booking-store.service';
import {AgreementService} from '../../../../../domain/agreement/agreement-service';
import {MY_BOOKING_ROUTES} from '../../../my-booking-routes';
import {catchError, delay, expand, take, takeUntil, tap} from 'rxjs/operators';
import {of, Subject} from 'rxjs';
import {MyAgreementSignStatus} from "../../../../../domain/booking/my-agreement-sign-status";

@Component({
  templateUrl: './agreements-sign-processing-page.component.html'
})
export class AgreementsSignProcessingPageComponent implements OnInit {
  booking: Booking | null = null;

  constructor(
    private rbRoutingService: RbRoutingService,
    private bookingStoreService: BookingStoreService,
    private agreementService: AgreementService) {
  }

  ngOnInit(): void {
    this.booking = this.bookingStoreService.get();
    if (!this.booking) {
      throw Error('Booking not found');
    }

    this.checkAgreementStatus(this.booking);
  }

  checkAgreementStatus(booking: Booking): void {
    const stopPolling$ = new Subject<void>();
    let lastBooking: any = null;
    let attemptCount = 0;

    of(null).pipe(
      expand(() => {
        attemptCount++;
        return this.agreementService.signed(booking.uuid).pipe(
          catchError(() => {
            this.navigateToErrorPage();
            stopPolling$.next();
            return of(null);
          }),
          tap(myBooking => {
            if (myBooking != null) {
              lastBooking = myBooking;
              this.bookingStoreService.set(myBooking);

              if (myBooking.booking?.agreement_sign_status === MyAgreementSignStatus.SIGNED) {
                this.navigateToSuccessPage();
                stopPolling$.next();
              }
            }
          }),
          delay(2000) // wait 2 seconds before the next attempt
        );
      }),
      take(10), // stop after 10 total attempts
      takeUntil(stopPolling$)
    ).subscribe({
      complete: () => {
        if (!lastBooking || lastBooking.booking?.agreement_sign_status !== MyAgreementSignStatus.SIGNED) {
          this.navigateToErrorPage();
        }
      }
    });
  }

  navigateToSuccessPage(): void {
    this.rbRoutingService.navToBookingsPath(this.booking, MY_BOOKING_ROUTES.AGREEMENTS_SIGN_SUCCESS, true);
  }

  navigateToErrorPage(): void {
    this.rbRoutingService.navToBookingsPath(this.booking, MY_BOOKING_ROUTES.AGREEMENTS_SIGN_ERROR, true);
  }
}
